import mod_examen from "@/store/mods/clinique/examens.js"
import mod_prestation from "@/store/mods/clinique/prestations.js"
import TypeFacturationChoix from '@/components/type-facturation-choix'
import ChoixPrestations from '@/components/choix-prestations'

export default {
    name: 'm-examen',
    components: { ChoixPrestations, TypeFacturationChoix },
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_examen: '',
            filtered_examens: [],
            exm_is_loading: true,
            exm_is_empty: false,

            types_examens: [],

            // Type de facturation (normal / urgence), remis à normal à chaque ouverture (15/10/2026)
            type_facturation: 'normal'
        }
    },

    watch: {
        filter_examen() {
            this.filterExamen()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        type_facturation() {
            this.retirerSansPrix()
        },

        refresh_state() {
            if (this.selected_slug == 'examen') {
                this.type_facturation = 'normal'
                this.$store.dispatch('getTypesFacturationPrestation')
                this.fetchExamen()
            }
        }
    },

    computed: {
        types_facturation_prestation() {
            return this.$store.getters['types_facturation_prestation']
        },

        champ_prix() {
            return (this.type_facturation === 'urgence') ? 'prix_urgence' : 'prix'
        },
        
    },

    mounted() {
        
    },

    methods: {
        fetchExamen() {
            this.exm_is_loading = true
            mod_examen.getExamens().then((types_examens) => {
                this.types_examens = types_examens
                if (this.types_examens.length == 0) {
                    this.exm_is_empty = true
                } else {
                    this.exm_is_empty = false
                    this.filtered_examens = this.types_examens
                }

                this.exm_is_loading = false
            }).catch(() => {
                this.exm_is_loading = false
                this.is_error = true
            })
        },

        hadleUndefinedPrice(examen) {
            if (this.type_facturation === 'urgence') {
                this.warningToast("Tarif urgence non configuré pour " + ((examen && examen.nom) ? examen.nom : "cet examen"))
                return
            }
            this.warningToast("Le prix de cet examen n'a pas été défini !")
        },

        /**
         * Prix de l'examen pour le type de facturation choisi (prix urgence NULL = non configuré)
         */
        prixSelonType(examen) {
            return Number((this.type_facturation === 'urgence') ? examen.prix_urgence : examen.prix)
        },

        /**
         * Changement de type : décocher les examens sans prix pour ce type
         */
        retirerSansPrix() {
            const sans_prix = this.one_is_checked.filter(examen => !(this.prixSelonType(examen) > 0))
            if (sans_prix.length == 0) {
                return
            }
            this.one_is_checked = this.one_is_checked.filter(examen => this.prixSelonType(examen) > 0)

            const motif = (this.type_facturation === 'urgence') ? 'Tarif urgence non configuré' : 'Prix non configuré'
            this.warningToast(motif + " pour " + sans_prix.map(examen => examen.nom).join(', ') + " (décoché(s))")
        },

        estExamenSelectionne(id) {
            return this.one_is_checked.some(item => Number(item.id) === Number(id))
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }

            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked.map(examen => Object.assign({}, examen, { type_facturation: this.type_facturation })),
                type_prestation: 'Examens',
                data_type: 'examen',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                // Urgence sans prix urgence configuré : jamais facturée, ni au prix normal
                const urgences_absentes = (response.prestations || []).filter(prestation => prestation.tarif_urgence_absent == 1)
                if (urgences_absentes.length > 0) {
                    this.save_loading = false
                    this.dangerToast("Tarif urgence non configuré pour " + urgences_absentes.map(prestation => prestation.libelle).join(', '))
                    return
                }

                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire
                
                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')
                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_exm.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_exm.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch((error) => {
                    this.save_loading = false
                    this.$refs.fpro_exm.click()
                    // Refus de la caisse (ex. 422 : tarif urgence non configuré) : afficher son message
                    this.dangerToast((error && error.response && error.response.data && error.response.data.message) || 'Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_exm.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })

            
        },

        filterExamen() {
            this.filtered_examens = [];

            if (this.filter_examen == '') {
                this.filtered_examens = this.types_examens
            } else {
                this.types_examens.forEach(examen => {
                    let cleaned_examen = this.removeAccents(examen.nom)
                    let cleaned_filter = this.removeAccents(this.filter_examen)

                    if (cleaned_examen.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_examens.push(examen)
                    }
                });
            }
        },
    }
}


